









import Vue from 'vue'
import request from '@/utils/request'
import changeUnit from '@/utils/changeUnit'
export default Vue.extend({
    data() {
        return {
            data: {},
        }
    },
    created() {
        request.get(`/api/cultural/column_rest/children_list/1`)
        .then((result) => {
            // console.log(result)
            this.data = result
        })
    },
    filters: {
        getChangeUnit(value: any) {
            return changeUnit.changeUnit(value)
        },
    },
})
